import React, { useEffect, useState } from "react";
import AdvanceDataTable from "../UI/Table/AdvanceDataTable";
import { ADMIN_BILLING_SUMMARY, ADMIN_TOTAL_BILLING_SUMMARY } from "../UI/Table/ColumnConst";
import EmptyImg from "../Dashboard/assets/img/create-project.png";
import ReactDatePicker from "react-datepicker";
import AdminLayout from "../UI/Layout/AdminLayout";
import Title from "../UI/Text/Title";
import Spining from "../UI/Spining/Spining";
import { userloginDetails } from "../Utils/AdminAuth";
import Select from "react-select";
import Axios from "axios";
import { HOST_URL, HOST_URL_DB2, NODE_HOST_URL } from "../Dashboard/api/Api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faCalendarAlt, faEdit, faEye, faSearch, faSort, faWallet } from "@fortawesome/free-solid-svg-icons";
import { IoLogoWhatsapp } from "react-icons/io";
import { FaEnvelope, FaSms, FaVoicemail } from "react-icons/fa";
import { MdChat } from "react-icons/md";

const BillingReport = () => {
    const lStorage = userloginDetails();
    const userId = lStorage?.user?.userId;
    const userToken = lStorage?.token;
    const adminType = lStorage?.user?.isAdmin;
    const [alert, setAlert] = useState({
        status: false,
        bgColor: "",
        errorMessage: "",
    });
    const [isLoading, setIsLoading] = useState(false);
    const [fromdate, setFromdate] = useState("");
    const [todate, setTodate] = useState("");
    const [allusers, setAllusers] = useState([]);
    const [selecteduser, setSelectedusers] = useState("");
    const [billData, setBillData] = useState('');
    const [searchData, setSearchData] = useState('')
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage] = useState(50);
    const [openAccordion, setOpenAccordion] = useState(null);
    const [parentList, setParentList] = useState([])
    const [selectedParent, setSelectedParent] = useState("");
    const [email, setEmail] = useState([]);
    const [sms, setSms] = useState([]);
    const [voice, setVoice] = useState([]);
    const [whatsappApi, setWhatsappApi] = useState([]);
    const [whatsappCampaign, setWhatsappCampaign] = useState([]);
    const [agentDetails, setAgentDetails] = useState([]);
    const [agentCount, setAgentCount] = useState('')
    const [FinalData, setFinalData] = useState({
        totalSms: 0,
        totalVoice: 0,
        totalEmail: 0,
        totalWhatsapp: 0,
        totalRevenue: 0
    });
    const [totalWhatsappCost, setTotalWhatsappCost] = useState(0);
    const [whatsappConversationSummary, setWhatsappConversationSummary] = useState([]);
    const [rcs, setRcs] = useState([]);
    const [channel, setChannel] = useState("");
    const [billStatus, setBillStatus] = useState({});
    const [openKeys, setOpenKeys] = useState([]); // keep track of open accordions
    const [otp, setOtp] = useState('');
    const [enterOtp, setEnterOtp] = useState(false)
    const [countryname, setCountryname] = useState([])
    const [smsTotalCost, setSmsTotalCost] = useState({
        delivered: 0,
        failed: 0,
        other: 0,
        total: 0,
        total_cost: 0,
        total_cost_parent: 0
    });
    const [emailTotalCost, setEmailTotalCost] = useState({
        delivered: 0,
        failed: 0,
        other: 0,
        total: 0,
        total_cost: 0,
        total_cost_parent: 0
    });
    const [rcsTotalCost, setRcsTotalCost] = useState({
        text: {
            delivered: 0,
            failed: 0,
            other: 0,
            contact_count: 0,
            block_cr: 0,
            block_cr_parent: 0,
        },
        richcardstandalone: {
            delivered: 0,
            failed: 0,
            other: 0,
            contact_count: 0,
            block_cr: 0,
            block_cr_parent: 0,
        },
        richcardcarousel: {
            delivered: 0,
            failed: 0,
            other: 0,
            contact_count: 0,
            block_cr: 0,
            block_cr_parent: 0,
        }
    });
    const [voiceTotalCost, setVoiceTotalCost] = useState({
        success: 0,
        failed: 0,
        submitted: 0,
        total: 0,
        total_cost: 0,
        total_cost_parent: 0,
        total_pulse_15p: 0,
        total_pulse_30p: 0
    });
    const [whatsappTotalCost, setWhatsappTotalCost] = useState({
        Utility: {
            delivered: 0,
            failed: 0,
            other: 0,
            total: 0,
            submission_cost_parent: 0,
            submission_cost_user: 0,
        },
        Marketing: {
            delivered: 0,
            failed: 0,
            other: 0,
            total: 0,
            submission_cost_parent: 0,
            submission_cost_user: 0,
        },
        Authentication: {
            delivered: 0,
            failed: 0,
            other: 0,
            total: 0,
            submission_cost_parent: 0,
            submission_cost_user: 0,
        }
    });
    const [sorted, setSorted] = useState(false);
    const [parentTotalAmount, setParentTotalAmount] = useState(0)


    const handleBillStatus = (username, newStatus) => {
        setBillStatus(prev => ({
            ...prev,
            [username]: newStatus
        }));

        if (newStatus === 'billed') {
            setEnterOtp(prev => ({
                ...prev,
                [username]: true
            }));
        } else {
            setEnterOtp(prev => ({
                ...prev,
                [username]: false
            }));
        }
    };

    const toggleAccordion = (key) => {
        setOpenKeys(prev =>
            prev.includes(key)
                ? prev.filter(k => k !== key)
                : [...prev, key]
        );
    };

    const totalActionData = (whatsappCampaign, whatsappApi) => {
        let totalWhatsappApiCost = 0;
        let totalWhatsappCampaignCost = 0;


        whatsappApi.forEach((x) => {
            totalWhatsappApiCost += parseFloat(x.total_billable_cost)
        });


        whatsappCampaign.forEach((x) => {
            totalWhatsappCampaignCost += parseFloat(x.per_wp_price) * parseFloat(x.total_delivered);
        });
        setTotalWhatsappCost(parseFloat(totalWhatsappApiCost + totalWhatsappCampaignCost))

        // If you want to return the total cost or set it elsewhere
        // setTotalWhatsappCost(totalWhatsappApiCost + totalWhatsappCampaignCost);
    }



    const totalData = (data) => {
        let totalcost = [];

        data.map((x) => {
            return (
                totalcost = x.per_wp_price * x.total_delivered
            )
        });

    }

    const customStyles = {
        control: (provided) => ({
            ...provided,
            cursor: "pointer",
        }),
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        option: (style) => ({
            ...style,
            fontSize: "12px",
        }),
    };

    useEffect(() => {
        ParentList();
        usersList();
        CountryName();
    }, []);

    const CountryName = async () => {
        try {
            let { data } = await Axios.post(`${HOST_URL}/country_master.php`)
            if (data.success) {
                setCountryname(data.data)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const ParentList = async () => {
        const parentParams = {
            user_id: userId,
            method: "retrieve",
            type: adminType,
            token: userToken
        }
        try {
            const { data } = await Axios.post(`${HOST_URL}/employee_user_list.php`, parentParams)
            if (data.success === true) {
                let result = data.data
                const formattedParent = result.map(user => ({
                    value: user.id,
                    label: user.email,
                    type: user.user_type
                }));
                setParentList(formattedParent);
            }
        } catch (error) {
            console.log(error);
        }
    }

    const handleParentChange = (selectedOption) => {
        setSelectedParent(selectedOption);
        setBillData("")
        if (selectedOption) {
            usersList(selectedOption.value);
        } else {
            usersList();
        }
        setAlert({ status: false });
    };

    const usersList = async (parentID) => {
        try {
            const response = await fetch(`${HOST_URL}/admin_user_list.php`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    user_id: userId,
                    method: "retrieve_all_user",
                    type: adminType,
                    token: userToken,
                }),
            });

            const result = await response.json();

            if (result.success) {
                const formattedUsers = result.data.map((user) => ({
                    value: user.id,
                    label: user.email,
                    parent: user.parent,
                }));

                const newData = formattedUsers?.filter((x) => x.parent === parentID);

                if (parentID) {
                    setAllusers(newData);
                } else {
                    setAllusers(formattedUsers);
                }
            }
        } catch (error) {
            console.error("Error fetching users:", error);
        }
    };


    const currentDate = (currentDate) => {
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, "0");
        const day = String(currentDate.getDate()).padStart(2, "0");
        const formattedDate = `${year}-${month}-${day}`;
        return formattedDate;
    };

    const fromdateHandler = (data) => {
        setFromdate(data);
        setAlert({ status: false });
    };

    const todateHandler = (data) => {
        setTodate(data);
        setAlert({ status: false });
    };

    const isValid = () => {
        if (!fromdate) {
            setAlert({
                status: true,
                bgColor: "alert alert-danger",
                errorMessage: "Please Select From Date",
            });
            return false
        }
        if (!todate) {
            setAlert({
                status: true,
                bgColor: "alert alert-danger",
                errorMessage: "Please Select To Date",
            });
            return false
        }
        else {
            return true
        }
    }

    const Submit = async () => {
        if (isValid()) {
            setIsLoading(true);

            const paramData = {
                user_id: userId,
                token: userToken,
                method: "admin_billing_summary",
                type: adminType,
                channel: channel || "all",
                parent_filter: userId || "all",
                user_filter: selecteduser?.value || "all",
                from_date: currentDate(fromdate),
                to_date: currentDate(todate),
            };

            const paramData2 = {
                user_id: userId,
                token: userToken,
                method: "rcs_billing_report",
                parent_filter: userId || "all",
                user_filter: selecteduser?.value || "all",
                from_date: currentDate(fromdate),
                to_date: currentDate(todate),
            };

            try {
                const [billingResult, rcsResult] = await Promise.allSettled([
                    Axios.post(`${HOST_URL_DB2}/billing_summary.php`, paramData),
                    Axios.post(`${NODE_HOST_URL}/billing_report`, paramData2),
                ]);

                let mergedData = {};

                const billingData =
                    billingResult.status === "fulfilled" &&
                        billingResult.value.data.success &&
                        billingResult.value.data.message
                        ? billingResult.value.data.message
                        : {};

                const rcsDataArray =
                    rcsResult.status === "fulfilled" &&
                        rcsResult.value.data.success &&
                        Array.isArray(rcsResult.value.data.data)
                        ? rcsResult.value.data.data
                        : [];

                // Start with billing data
                const billingMap = { ...billingData };

                // Merge RCS data
                rcsDataArray.forEach((rcsUser) => {
                    const uid = parseInt(rcsUser.user_id, 10);
                    const username = rcsUser.username;
                    const parentname = rcsUser.parent_username
                    const rcsRawArray = Array.isArray(rcsUser.data) ? rcsUser.data : [];

                    // Convert RCS array to object: { PANEL: {...}, API: {...} }
                    const rcsObj = {};
                    rcsRawArray.forEach((entry) => {
                        if (entry?.submit_from) {
                            rcsObj[entry.submit_from] = entry;
                        }
                    });

                    // Find billing match by user_id
                    const matchingKey = Object.keys(billingMap).find(
                        (key) => parseInt(billingMap[key]?.user_id, 10) === uid
                    );

                    if (matchingKey) {
                        billingMap[matchingKey] = {
                            ...billingMap[matchingKey],
                            rcs: rcsObj,
                        };
                    } else {
                        // If user is not in billing, add new
                        billingMap[username] = {
                            username,
                            parentname,
                            user_id: uid,
                            rcs: rcsObj,
                        };
                    }
                });

                mergedData = billingMap;

                // console.log("✅ Final Merged & Transformed Data:", mergedData);
                const enrichedData = Object.entries(mergedData).map(([username, data]) => {
                    return {
                        username,
                        ...data,
                        totalAmount: calculateTotalAmount(data)
                    };
                });

                console.log(enrichedData);
                

                // Parent Report's "Total Amount" is set inside TotalParentData —
                // it's the sum of the Parent Cost column across all channels,
                // not the user-side totalAmount.
                setBillData(enrichedData);
                TotalCountData(enrichedData);
                TotalParentData(enrichedData);
                // CountryName(enrichedData)
            } catch (error) {
                console.error("❗ Unexpected error in Submit:", error);
            } finally {
                setIsLoading(false);
            }
        }
    };

    const calculateTotalAmount = (data) => {
        let total = 0;

        const smsapi = data?.sms?.api;
        const smsCamp = data?.sms?.camp;
        const whatsappapi = data?.whatsapp?.api;
        const whatsappcamp = data?.whatsapp?.camp
        const rcspannel = data?.rcs?.PANEL?.data
        const rcsbulkapi = data?.rcs?.BULKAPI?.data
        const campMulti = data?.whatsapp?.camp_multi

        if (smsapi && typeof smsapi === 'object') {
            Object.keys(smsapi).forEach((apidata) => {
                total += parseFloat(smsapi[apidata].total_cost || 0);
            });
        }

        if (smsCamp && typeof smsCamp === 'object') {
            Object.keys(smsCamp).forEach((campdata) => {
                total += parseFloat(smsCamp[campdata].total_cost_user || 0)
            });
        }

        if (whatsappapi && typeof whatsappapi === 'object') {
            Object.keys(whatsappapi).forEach((apidata) => {
                total += parseFloat((whatsappapi[apidata]?.Utility?.submission_cost_user || 0) + (whatsappapi[apidata]?.Marketing?.submission_cost_user || 0) + (whatsappapi[apidata]?.Authentication?.submission_cost_user || 0))
            });
        }

        if (whatsappcamp && typeof whatsappcamp === 'object') {
            Object.keys(whatsappcamp).forEach((campdata) => {
                total += parseFloat((whatsappcamp[campdata]?.Utility?.submission_cost_user || 0) + (whatsappcamp[campdata]?.Marketing?.submission_cost_user || 0) + (whatsappcamp[campdata]?.Authentication?.submission_cost_user || 0))
            });
        }

        if (campMulti && typeof campMulti === 'object') {
            Object.keys(campMulti).forEach((campdata) => {
                total += parseFloat((campMulti[campdata]?.Utility?.submission_cost_user || 0) + (campMulti[campdata]?.Marketing?.submission_cost_user || 0) + (campMulti[campdata]?.Authentication?.submission_cost_user || 0))
            });
        }

        if (Array.isArray(rcspannel)) {
            rcspannel.map((x) => {
                total += parseFloat(x.data.block_cr || 0);
            });
        }

        if (Array.isArray(rcsbulkapi)) {
            rcsbulkapi.map((x) => {
                total += parseFloat(x.data.block_cr || 0);
            });
        }

        const voice = data?.voice?.api
        total += parseFloat(voice?.total_cost || 0)

        const email = data?.email?.api
        total += parseFloat(email?.total_cost || 0)


        return total;
    };



    const handleSort = () => {
        const updatedData = billData.map((item) => {
            const totalAmount = calculateTotalAmount(item);
            return {
                ...item,
                totalAmount, // attach freshly calculated amount
            };
        });

        const sortedData = updatedData.sort((a, b) =>
            sorted ? a.totalAmount - b.totalAmount : b.totalAmount - a.totalAmount
        );
        setBillData(sortedData);
        setSorted(!sorted);
    };



    const TotalParentData = (data) => {
        // Initialize SMS totals
        let smsapi = {
            delivered: 0, failed: 0, other: 0, total: 0, total_cost: 0, total_cost_parent: 0
        };
        let smsCamp = {
            delivered: 0, failed: 0, other: 0, total: 0, total_cost: 0, total_cost_parent: 0
        };

        // Initialize WhatsApp totals
        let whatsappApi = {
            Utility: { total: 0, delivered: 0, failed: 0, other: 0, submission_cost_parent: 0, submission_cost_user: 0 },
            Marketing: { total: 0, delivered: 0, failed: 0, other: 0, submission_cost_parent: 0, submission_cost_user: 0 },
            Authentication: { total: 0, delivered: 0, failed: 0, other: 0, submission_cost_parent: 0, submission_cost_user: 0 },
        };
        let whatsappCamp = {
            Utility: { total: 0, delivered: 0, failed: 0, other: 0, submission_cost_parent: 0, submission_cost_user: 0 },
            Marketing: { total: 0, delivered: 0, failed: 0, other: 0, submission_cost_parent: 0, submission_cost_user: 0 },
            Authentication: { total: 0, delivered: 0, failed: 0, other: 0, submission_cost_parent: 0, submission_cost_user: 0 },
        };

        let whatsappCampMulti = {
            Utility: { total: 0, delivered: 0, failed: 0, other: 0, submission_cost_parent: 0, submission_cost_user: 0 },
            Marketing: { total: 0, delivered: 0, failed: 0, other: 0, submission_cost_parent: 0, submission_cost_user: 0 },
            Authentication: { total: 0, delivered: 0, failed: 0, other: 0, submission_cost_parent: 0, submission_cost_user: 0 },
        };

        let emailApi = {
            delivered: 0, failed: 0, other: 0, total: 0, total_cost: 0, total_cost_parent: 0
        };

        let voiceApi = {
            success: 0, failed: 0, submitted: 0, total: 0, total_cost: 0, total_cost_parent: 0, total_pulse_15p: 0, total_pulse_30p: 0
        }

        let rcsApi = {
            text: { contact_count: 0, delivered: 0, failed: 0, other: 0, block_cr_parent: 0, block_cr: 0 },
            richcardstandalone: { contact_count: 0, delivered: 0, failed: 0, other: 0, block_cr_parent: 0, block_cr: 0 },
            richcardcarousel: { contact_count: 0, delivered: 0, failed: 0, other: 0, block_cr_parent: 0, block_cr: 0 },
        };
        let rcsPannel = {
            text: { contact_count: 0, delivered: 0, failed: 0, other: 0, block_cr_parent: 0, block_cr: 0 },
            richcardstandalone: { contact_count: 0, delivered: 0, failed: 0, other: 0, block_cr_parent: 0, block_cr: 0 },
            richcardcarousel: { contact_count: 0, delivered: 0, failed: 0, other: 0, block_cr_parent: 0, block_cr: 0 },
        };

        Object.keys(data || {}).forEach((itemKey) => {
            const item = data[itemKey];

            // SMS API
            const smsApiData = item?.sms?.api;
            if (smsApiData && typeof smsApiData === 'object') {
                Object.values(smsApiData).forEach((sms) => {
                    smsapi.delivered += parseInt(sms?.delivered) || 0;
                    smsapi.failed += parseInt(sms?.failed) || 0;
                    smsapi.other += parseInt(sms?.other) || 0;
                    smsapi.total += parseInt(sms?.total) || 0;
                    smsapi.total_cost += parseInt(sms?.total_cost) || 0;
                    smsapi.total_cost_parent += parseInt(sms?.total_cost_parent) || 0;
                });
            }

            // SMS Campaign
            const smsCampData = item?.sms?.camp;
            if (smsCampData && typeof smsCampData === 'object') {
                Object.values(smsCampData).forEach((sms) => {
                    smsCamp.delivered += parseInt(sms?.delivered) || 0;
                    smsCamp.failed += parseInt(sms?.failed) || 0;
                    smsCamp.other += parseInt(sms?.other) || 0;
                    smsCamp.total += parseInt(sms?.total) || 0;
                    smsCamp.total_cost += parseInt(sms?.total_cost_user) || 0;
                    smsCamp.total_cost_parent += parseInt(sms?.total_cost_parent) || 0;
                });
            }

            // WhatsApp API
            const waApiData = item?.whatsapp?.api;
            if (waApiData && typeof waApiData === 'object') {
                Object.values(waApiData).forEach((wa) => {
                    ['Utility', 'Marketing', 'Authentication'].forEach((type) => {
                        whatsappApi[type].delivered += parseInt(wa?.[type]?.delivered) || 0;
                        whatsappApi[type].failed += parseInt(wa?.[type]?.failed) || 0;
                        whatsappApi[type].other += parseInt(wa?.[type]?.other) || 0;
                        whatsappApi[type].total += parseInt(wa?.[type]?.total) || 0;
                        whatsappApi[type].submission_cost_parent += parseInt(wa?.[type]?.submission_cost_parent) || 0;
                        whatsappApi[type].submission_cost_user += parseInt(wa?.[type]?.submission_cost_user) || 0;
                    });
                });
            }

            // WhatsApp Campaign
            const waCampData = item?.whatsapp?.camp;
            if (waCampData && typeof waCampData === 'object') {
                Object.values(waCampData).forEach((wa) => {
                    ['Utility', 'Marketing', 'Authentication'].forEach((type) => {
                        whatsappCamp[type].delivered += parseInt(wa?.[type]?.delivered) || 0;
                        whatsappCamp[type].failed += parseInt(wa?.[type]?.failed) || 0;
                        whatsappCamp[type].other += parseInt(wa?.[type]?.other) || 0;
                        whatsappCamp[type].total += parseInt(wa?.[type]?.total) || 0;
                        whatsappCamp[type].submission_cost_parent += parseInt(wa?.[type]?.submission_cost_parent) || 0;
                        whatsappCamp[type].submission_cost_user += parseInt(wa?.[type]?.submission_cost_user) || 0;
                    });
                });
            }

            const waCampDataMulti = item?.whatsapp?.camp_multi;
            if (waCampDataMulti && typeof waCampDataMulti === 'object') {
                Object.values(waCampDataMulti).forEach((wa) => {
                    ['Utility', 'Marketing', 'Authentication'].forEach((type) => {
                        whatsappCampMulti[type].delivered += parseInt(wa?.[type]?.delivered) || 0;
                        whatsappCampMulti[type].failed += parseInt(wa?.[type]?.failed) || 0;
                        whatsappCampMulti[type].other += parseInt(wa?.[type]?.other) || 0;
                        whatsappCampMulti[type].total += parseInt(wa?.[type]?.total) || 0;
                        whatsappCampMulti[type].submission_cost_parent += parseInt(wa?.[type]?.submission_cost_parent) || 0;
                        whatsappCampMulti[type].submission_cost_user += parseInt(wa?.[type]?.submission_cost_user) || 0;
                    });
                });
            }


            const emailApiData = item?.email?.api;
            if (emailApiData && typeof emailApiData === 'object') {
                emailApi.delivered += parseInt(emailApiData?.delivered) || 0;
                emailApi.failed += parseInt(emailApiData?.failed) || 0;
                emailApi.other += parseInt(emailApiData?.other) || 0;
                emailApi.total += parseInt(emailApiData?.total) || 0;
                emailApi.total_cost += parseInt(emailApiData?.total_cost) || 0;
                emailApi.total_cost_parent += parseInt(emailApiData?.total_cost_parent) || 0;
            }

            const voiceApiData = item?.voice?.api;
            if (voiceApiData && typeof voiceApiData === 'object') {
                voiceApi.success += parseInt(voiceApiData?.success) || 0;
                voiceApi.failed += parseInt(voiceApiData?.failed) || 0;
                voiceApi.submitted += parseInt(voiceApiData?.submitted) || 0;
                voiceApi.total += parseInt(voiceApiData?.total) || 0;
                voiceApi.total_cost += parseInt(voiceApiData?.total_cost) || 0;
                voiceApi.total_cost_parent += parseInt(voiceApiData?.total_cost_parent) || 0;
                voiceApi.total_pulse_15p += parseInt(voiceApiData?.total_pulse_15p) || 0;
                voiceApi.total_pulse_30p += parseInt(voiceApiData?.total_pulse_30p) || 0;
            }

           const rcsData = item?.rcs?.PANEL?.data;
            const rcsApiData = item?.rcs?.BULKAPI?.data;
            // console.log(rcsData)
            if (Array.isArray(rcsData)) {
                rcsData.map((x) => {
                    // console.log(x);
                    
                    if (x.rcs_type === "text") {
                        rcsPannel.text.contact_count += x.data.contact_count
                        rcsPannel.text.delivered += x.data.deliver_count
                        rcsPannel.text.failed += x.data.fail_count
                        rcsPannel.text.other += x.data.other_count
                        rcsPannel.text.block_cr += x.data.block_cr
                        rcsPannel.text.block_cr_parent += x.data.block_cr_parent
                    }
                    else if (x.rcs_type === "richcardstandalone") {
                        rcsPannel.richcardstandalone.contact_count += x.data.contact_count
                        rcsPannel.richcardstandalone.delivered += x.data.deliver_count
                        rcsPannel.richcardstandalone.failed += x.data.fail_count
                        rcsPannel.richcardstandalone.other += x.data.other_count
                        rcsPannel.richcardstandalone.block_cr += x.data.block_cr
                        rcsPannel.richcardstandalone.block_cr_parent += x.data.block_cr_parent
                    }
                    else if (x.rcs_type === "richcardcarousel") {
                        rcsPannel.richcardcarousel.contact_count += x.data.contact_count
                        rcsPannel.richcardcarousel.delivered += x.data.deliver_count
                        rcsPannel.richcardcarousel.failed += x.data.fail_count
                        rcsPannel.richcardcarousel.other += x.data.other_count
                        rcsPannel.richcardcarousel.block_cr += x.data.block_cr
                        rcsPannel.richcardcarousel.block_cr_parent += x.data.block_cr_parent
                    }
                });
            } else {
                console.warn("rcsData is not an array or is undefined:", rcsData);
            }

            if (Array.isArray(rcsApiData)) {
                rcsApiData.map((x) => {
                    // console.log(x);
                    
                    if (x.rcs_type === "text") {
                        rcsApi.text.contact_count += x?.data?.contact_count
                        rcsApi.text.delivered += x.data.deliver_count
                        rcsApi.text.failed += x.data.fail_count
                        rcsApi.text.other += x.data.other_count
                        rcsApi.text.block_cr += x.data.block_cr
                        rcsApi.text.block_cr_parent += x.data.block_cr_parent
                    }
                    else if (x.rcs_type === "richcardstandalone") {
                        rcsApi.richcardstandalone.contact_count += x.data.contact_count
                        rcsApi.richcardstandalone.delivered += x.data.deliver_count
                        rcsApi.richcardstandalone.failed += x.data.fail_count
                        rcsApi.richcardstandalone.other += x.data.other_count
                        rcsApi.richcardstandalone.block_cr += x.data.block_cr
                        rcsApi.richcardstandalone.block_cr_parent += x.data.block_cr_parent
                    }
                    else if (x.rcs_type === "richcardcarousel") {
                        rcsApi.richcardcarousel.contact_count += x.data.contact_count
                        rcsApi.richcardcarousel.delivered += x.data.deliver_count
                        rcsApi.richcardcarousel.failed += x.data.fail_count
                        rcsApi.richcardcarousel.other += x.data.other_count
                        rcsApi.richcardcarousel.block_cr += x.data.block_cr
                        rcsApi.richcardcarousel.block_cr_parent += x.data.block_cr_parent
                    }
                });
            } else {
                console.warn("rcsData is not an array or is undefined:", rcsApiData);
            }

            // if (rcsData && typeof rcsData === 'object') {
            //     rcsApi.delivered += parseInt(rcsData?.deliver_count) || 0;
            //     rcsApi.failed += parseInt(rcsData?.fail_count) || 0;
            //     rcsApi.other += parseInt(rcsData?.other_count) || 0;
            //     rcsApi.contact_count += parseInt(rcsData?.contact_count) || 0;
            //     rcsApi.block_cr += parseInt(rcsData?.block_cr) || 0;
            //     rcsApi.block_cr_parent += parseInt(rcsData?.block_cr_parent) || 0;
            // }
        });

        // Combine SMS totals and set in state
        setSmsTotalCost({
            delivered: smsapi.delivered + smsCamp.delivered,
            failed: smsapi.failed + smsCamp.failed,
            other: smsapi.other + smsCamp.other,
            total: smsapi.total + smsCamp.total,
            total_cost: smsapi.total_cost + smsCamp.total_cost,
            total_cost_parent: smsapi.total_cost_parent + smsCamp.total_cost_parent
        });

        setEmailTotalCost({
            delivered: emailApi.delivered,
            failed: emailApi.failed,
            other: emailApi.other,
            total: emailApi.total,
            total_cost: emailApi.total_cost,
            total_cost_parent: emailApi.total_cost_parent
        });

        setRcsTotalCost({
            text: {
                delivered: rcsPannel.text.delivered,
                failed: rcsPannel.text.failed,
                other: rcsPannel.text.other,
                contact_count: rcsPannel.text.contact_count,
                block_cr: rcsPannel.text.block_cr,
                block_cr_parent: rcsPannel.text.block_cr_parent,
            },
            richcardstandalone: {
                delivered: rcsPannel.richcardstandalone.delivered,
                failed: rcsPannel.richcardstandalone.failed,
                other: rcsPannel.richcardstandalone.other,
                contact_count: rcsPannel.richcardstandalone.contact_count,
                block_cr: rcsPannel.richcardstandalone.block_cr,
                block_cr_parent: rcsPannel.richcardstandalone.block_cr_parent,
            },
            richcardcarousel: {
                delivered: rcsPannel.richcardcarousel.delivered,
                failed: rcsPannel.richcardcarousel.failed,
                other: rcsPannel.richcardcarousel.other,
                contact_count: rcsPannel.richcardcarousel.contact_count,
                block_cr: rcsPannel.richcardcarousel.block_cr,
                block_cr_parent: rcsPannel.richcardcarousel.block_cr_parent,
            }
        })

        setVoiceTotalCost({
            success: voiceApi.success,
            failed: voiceApi.failed,
            submitted: voiceApi.submitted,
            total: voiceApi.total,
            total_cost: voiceApi.total_cost,
            total_cost_parent: voiceApi.total_cost_parent,
            total_pulse_15p: voiceApi.total_pulse_15p,
            total_pulse_30p: voiceApi.total_pulse_30p
        })

        // Combine WhatsApp API + Campaign totals for Utility, Marketing, Authentication
        let whatsappTotal = {
            Utility: { delivered: 0, failed: 0, other: 0, total: 0, submission_cost_parent: 0, submission_cost_user: 0 },
            Marketing: { delivered: 0, failed: 0, other: 0, total: 0, submission_cost_parent: 0, submission_cost_user: 0 },
            Authentication: { delivered: 0, failed: 0, other: 0, total: 0, submission_cost_parent: 0, submission_cost_user: 0 },
        };

        ['Utility', 'Marketing', 'Authentication'].forEach((type) => {
            whatsappTotal[type].delivered = whatsappApi[type].delivered + whatsappCamp[type].delivered + whatsappCampMulti[type].delivered;
            whatsappTotal[type].failed = whatsappApi[type].failed + whatsappCamp[type].failed + whatsappCampMulti[type].failed;
            whatsappTotal[type].other = whatsappApi[type].other + whatsappCamp[type].other + whatsappCampMulti[type].other;
            whatsappTotal[type].total = whatsappApi[type].total + whatsappCamp[type].total + whatsappCampMulti[type].total;
            whatsappTotal[type].submission_cost_parent = whatsappApi[type].submission_cost_parent + whatsappCamp[type].submission_cost_parent + whatsappCampMulti[type].submission_cost_parent;
            whatsappTotal[type].submission_cost_user = whatsappApi[type].submission_cost_user + whatsappCamp[type].submission_cost_user + whatsappCampMulti[type].submission_cost_user;
        });

        // Store in state
        setWhatsappTotalCost(whatsappTotal);

        // "Total Amount" shown on the Parent Report header = sum of the Parent Cost
        // column across every channel row of that table: WhatsApp (Utility/Marketing/
        // Authentication submission_cost_parent), SMS (api+camp total_cost_parent),
        // RCS panel types (block_cr_parent), Voice and Email (total_cost_parent).
        const totalParentAmount =
            (parseFloat(whatsappTotal.Utility.submission_cost_parent) || 0) +
            (parseFloat(whatsappTotal.Marketing.submission_cost_parent) || 0) +
            (parseFloat(whatsappTotal.Authentication.submission_cost_parent) || 0) +
            (parseFloat(smsapi.total_cost_parent) || 0) +
            (parseFloat(smsCamp.total_cost_parent) || 0) +
            (parseFloat(rcsPannel.text.block_cr_parent) || 0) +
            (parseFloat(rcsPannel.richcardstandalone.block_cr_parent) || 0) +
            (parseFloat(rcsPannel.richcardcarousel.block_cr_parent) || 0) +
            (parseFloat(voiceApi.total_cost_parent) || 0) +
            (parseFloat(emailApi.total_cost_parent) || 0);
        setParentTotalAmount(totalParentAmount);
    };

    const TotalCountData = (data) => {
        let totalSms = 0;
        let totalVoice = 0;
        let totalEmail = 0;
        let totalWhatsapp = 0;
        let totalRevenue = 0;

        // data.forEach((x) => {
        //     totalSms += parseFloat(x.total_sms_summary) || 0;
        //     totalVoice += parseFloat(x.total_voice_summary) || 0;
        //     totalEmail += parseFloat(x.total_email_summary) || 0;
        //     totalWhatsapp += parseFloat(x.grand_total_summary) || 0;
        //     totalRevenue += parseFloat(x.total_sms_summary + x.total_voice_summary + x.total_email_summary + x.grand_total_summary)
        // });

        setFinalData({
            totalSms: totalSms,
            totalVoice: totalVoice,
            totalEmail: totalEmail,
            totalWhatsapp: totalWhatsapp,
            totalRevenue: totalRevenue
        });
    };

    const today = new Date();

    // 2 days before today
    const cutoffDate = new Date(today);
    cutoffDate.setDate(today.getDate() - 2);

    const filterToDate = (date) => {
        if (!fromdate) return false; // Disable everything until fromdate selected

        const selectedMonth = fromdate.getMonth();
        const selectedYear = fromdate.getFullYear();

        return (
            date.getMonth() === selectedMonth &&
            date.getFullYear() === selectedYear
        );
    };

    const usersArray = Object.entries(billData).map(([email, details]) => ({
        email,
        ...details
    }));

    const handleChannelChange = (e) => {
        setChannel(e.target.value)
        setBillData([]);
    }

    const handleUserChange = (selectedOption) => {
        setSelectedusers(selectedOption);
        setBillData("")
    }

    return (
        <div>
            <AdminLayout>
                <Title isButton={false}> Billing Report </Title>
                {Object.keys(billData).length > 0 && (
                    <div className="container my-3">
                        <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5 g-4 justify-content-center">

                            {/* WhatsApp */}
                            <div className="col mb-2">
                                <div className="card shadow-sm border-0 h-100" style={{ minHeight: "150px" }}>
                                    <div className="card-body text-center">
                                        <IoLogoWhatsapp style={{ fontSize: "1.9em", color: "#25D366" }} className="mb-2" />
                                        <h5 className="card-title mb-1">WhatsApp</h5>
                                        <div className="d-flex justify-content-between mt-3">
                                            <div>
                                                <p className="mb-1 text-muted small">Total</p>
                                                <h6 className="mb-0">
                                                    {whatsappTotalCost.Utility.total +
                                                        whatsappTotalCost.Marketing.total +
                                                        whatsappTotalCost.Authentication.total}
                                                </h6>
                                            </div>
                                            <div>
                                                <p className="mb-1 text-muted small">Delivered</p>
                                                <h6 className="mb-0">
                                                    {whatsappTotalCost.Utility.delivered +
                                                        whatsappTotalCost.Marketing.delivered +
                                                        whatsappTotalCost.Authentication.delivered}
                                                </h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* SMS */}
                            <div className="col mb-2">
                                <div className="card shadow-sm border-0 h-100" style={{ minHeight: "150px" }}>
                                    <div className="card-body text-center">
                                        <FaSms style={{ fontSize: "1.9em", color: "#007bff" }} className="mb-2" />
                                        <h5 className="card-title mb-1">SMS</h5>
                                        <div className="d-flex justify-content-between mt-3">
                                            <div>
                                                <p className="mb-1 text-muted small">Total</p>
                                                <h6 className="mb-0">{smsTotalCost.total}</h6>
                                            </div>
                                            <div>
                                                <p className="mb-1 text-muted small">Delivered</p>
                                                <h6 className="mb-0">{smsTotalCost.delivered}</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* RCS */}
                            <div className="col mb-2">
                                <div className="card shadow-sm border-0 h-100" style={{ minHeight: "150px" }}>
                                    <div className="card-body text-center">
                                        <MdChat style={{ fontSize: "1.9em", color: "#17a2b8" }} className="mb-2" />
                                        <h5 className="card-title mb-1">RCS</h5>
                                        <div className="d-flex justify-content-between mt-3">
                                            <div>
                                                <p className="mb-1 text-muted small">Total</p>
                                                <h6 className="mb-0">
                                                    {rcsTotalCost.text.contact_count +
                                                        rcsTotalCost.richcardstandalone.contact_count +
                                                        rcsTotalCost.richcardcarousel.contact_count}
                                                </h6>
                                            </div>
                                            <div>
                                                <p className="mb-1 text-muted small">Delivered</p>
                                                <h6 className="mb-0">
                                                    {rcsTotalCost.text.delivered +
                                                        rcsTotalCost.richcardstandalone.delivered +
                                                        rcsTotalCost.richcardcarousel.delivered}
                                                </h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Voice */}
                            <div className="col mb-2">
                                <div className="card shadow-sm border-0 h-100" style={{ minHeight: "150px" }}>
                                    <div className="card-body text-center">
                                        <FaVoicemail style={{ fontSize: "1.9em", color: "#fd7e14" }} className="mb-2" />
                                        <h5 className="card-title mb-1">Voice</h5>
                                        <div className="d-flex justify-content-between mt-3">
                                            <div>
                                                <p className="mb-1 text-muted small">Total</p>
                                                <h6 className="mb-0">{voiceTotalCost.total}</h6>
                                            </div>
                                            <div>
                                                <p className="mb-1 text-muted small">Delivered</p>
                                                <h6 className="mb-0">{voiceTotalCost.success}</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Email */}
                            <div className="col mb-2">
                                <div className="card shadow-sm border-0 h-100" style={{ minHeight: "150px" }}>
                                    <div className="card-body text-center">
                                        <FaEnvelope style={{ fontSize: "1.9em", color: "#dc3545" }} className="mb-2" />
                                        <h5 className="card-title mb-1">Email</h5>
                                        <div className="d-flex justify-content-between mt-3">
                                            <div>
                                                <p className="mb-1 text-muted small">Total</p>
                                                <h6 className="mb-0">{emailTotalCost.total}</h6>
                                            </div>
                                            <div>
                                                <p className="mb-1 text-muted small">Delivered</p>
                                                <h6 className="mb-0">{emailTotalCost.delivered}</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                )}

                {alert.status === true ? (
                    <div className={alert.bgColor} role="alert">
                        <button
                            type="button"
                            className="close"
                            data-dismiss="alert"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">×</span>
                        </button>
                        <div className="">{alert.errorMessage}</div>
                    </div>
                ) : null}
                <div className="row">
                    <div className="">
                        <div className="card">
                            {isLoading && <Spining />}

                            <div className="card-body">
                                <div className="filter-option">
                                    <h6 className="card-subtitle text-muted">Billing Summary</h6>
                                    <div className="row mb-2">
                                        {/* <div className="col-4">
                                            <select className="form-control" value={channel} onChange={handleChannelChange}>
                                                <option value="all">All Channel</option>
                                                <option value="sms">SMS</option>
                                                <option value="whatsapp">Whatsapp</option>
                                                <option value="rcs">RCS</option>
                                                <option value="voice">Voice</option>
                                                <option value="email">Email</option>
                                            </select>
                                        </div> */}
                                        {/* <div className="col-md-6">
                                            <Select
                                                onChange={handleParentChange}
                                                options={parentList}
                                                value={selectedParent}
                                                isSearchable={true}
                                                placeholder="All Parent"
                                                isClearable={true}
                                                styles={customStyles}
                                            // isDisabled={true}
                                            // isDisabled={this.state.updateId ? true : false}
                                            />
                                        </div> */}
                                        <div className="col-md-8">
                                            <Select
                                                onChange={handleUserChange}
                                                options={allusers}
                                                value={selecteduser}
                                                isSearchable={true}
                                                placeholder="All Users"
                                                isClearable={true}
                                                styles={customStyles}
                                            // isDisabled={true}
                                            // isDisabled={this.state.updateId ? true : false}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <button type="button" onClick={Submit} className="btn btn-sm btn-info float-right">Submit</button>
                                        </div>

                                    </div>

                                    <div className="row mb-3">
                                        <div className="col-md-6">
                                            <div className="input-group mb-2 mr-sm-2 table4">
                                                <div className="input-group-text">
                                                    <FontAwesomeIcon icon={faCalendarAlt} />
                                                </div>
                                                <ReactDatePicker
                                                    className="form-control btn-block"
                                                    dateFormat="dd/MM/yyyy"
                                                    selected={fromdate}
                                                    onChange={fromdateHandler}
                                                    placeholderText="From Date"
                                                    // filterDate={filterAllowedDates}
                                                    maxDate={cutoffDate}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="input-group mb-2 mr-sm-2 table5">
                                                <div className="input-group-text">
                                                    <FontAwesomeIcon icon={faCalendarAlt} />
                                                </div>
                                                <ReactDatePicker
                                                    className="form-control btn-block"
                                                    dateFormat="dd/MM/yyyy"
                                                    selected={todate}
                                                    onChange={todateHandler}
                                                    placeholderText="To Date"
                                                    maxDate={cutoffDate}
                                                    filterDate={filterToDate}
                                                />
                                            </div>
                                        </div>

                                    </div>
                                </div>

                                {/* <form className="form-row mb-3" id="EntityFormidFrom">
                                    <div className="col-md-12 d-flex justify-content-center mt-3">
                                        <button type="button" onClick={search} className="btn btn-sm btn-success">Submit</button>
                                    </div>
                                </form> */}

                                <div className="card">
                                    {/* <AdvanceDataTable
                                        tableName={""}
                                        tableCell={ADMIN_TOTAL_BILLING_SUMMARY}
                                        tableData={billData}
                                        isLoading={isLoading}
                                        isError={alert.errorMessage}
                                        filterstatus={true}
                                        pagination={true}
                                    /> */}

                                    <div className="">
                                        <div className="">

                                            <div className="p-2">

                                                <div className="">
                                                    <div className=" flex-fill">
                                                        {billData ?
                                                            <>

                                                                <div className="card">
                                                                    <div className="card-body">
                                                                        <div className="row">
                                                                            <div className="col-6">
                                                                                <h6 className="mb-3">Parent Report</h6>
                                                                            </div>
                                                                            <div className="col-6">
                                                                                <h6 className="mb-3 float-right">Total Amount : {parentTotalAmount}</h6>
                                                                            </div>
                                                                        </div>
                                                                        <div className="table-responsive">
                                                                            <table className="table table-striped table-bordered mb-0">
                                                                                <thead className="bg-secondary text-white">
                                                                                    <tr>
                                                                                        <th>Channel</th>
                                                                                        <th>Category</th>
                                                                                        <th>CountryCode</th>
                                                                                        <th>Total</th>
                                                                                        <th>Delivered</th>
                                                                                        <th>Failed</th>
                                                                                        <th>Other</th>
                                                                                        <th>User Pulse (Voice)</th>
                                                                                        <th>User Cost</th>
                                                                                        <th>Parent Cost</th>
                                                                                        {/* <th>Total Cost</th> */}
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {/* Whatsapp divided into Utility, Marketing, Authentication */}
                                                                                    <tr>
                                                                                        <td rowSpan="3">
                                                                                            <IoLogoWhatsapp style={{ fontSize: '1.8em', color: '#25D366' }} className="mr-2" />
                                                                                            Whatsapp
                                                                                        </td>
                                                                                        <td>Utility</td>
                                                                                        <td>91</td>
                                                                                        <td>{whatsappTotalCost.Utility.total}</td>
                                                                                        <td>{whatsappTotalCost.Utility.delivered}</td>
                                                                                        <td>{whatsappTotalCost.Utility.failed}</td>
                                                                                        <td>{whatsappTotalCost.Utility.other}</td>
                                                                                        <td>-</td>
                                                                                        <td>{whatsappTotalCost.Utility.submission_cost_user}</td>
                                                                                        <td>{whatsappTotalCost.Utility.submission_cost_parent}</td>
                                                                                    </tr>

                                                                                    <tr>
                                                                                        <td>Marketing</td>
                                                                                        <td>91</td>
                                                                                        <td>{whatsappTotalCost.Marketing.total}</td>
                                                                                        <td>{whatsappTotalCost.Marketing.delivered}</td>
                                                                                        <td>{whatsappTotalCost.Marketing.failed}</td>
                                                                                        <td>{whatsappTotalCost.Marketing.other}</td>
                                                                                        <td>-</td>
                                                                                        <td>{whatsappTotalCost.Marketing.submission_cost_user}</td>
                                                                                        <td>{whatsappTotalCost.Marketing.submission_cost_parent}</td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td>Authentication</td>
                                                                                        <td>91</td>
                                                                                        <td>{whatsappTotalCost.Authentication.total}</td>
                                                                                        <td>{whatsappTotalCost.Authentication.delivered}</td>
                                                                                        <td>{whatsappTotalCost.Authentication.failed}</td>
                                                                                        <td>{whatsappTotalCost.Authentication.other}</td>
                                                                                        <td>-</td>
                                                                                        <td>{whatsappTotalCost.Authentication.submission_cost_user}</td>
                                                                                        <td>{whatsappTotalCost.Authentication.submission_cost_parent}</td>
                                                                                    </tr>

                                                                                    {/* SMS */}
                                                                                    <tr>
                                                                                        <td>
                                                                                            <FaSms style={{ fontSize: '1.8em', color: '#007bff' }} className="mr-2" />
                                                                                            SMS
                                                                                        </td>
                                                                                        <td>-</td>
                                                                                        <td>91</td>
                                                                                        <td>{smsTotalCost.total}</td>
                                                                                        <td>{smsTotalCost.delivered}</td>
                                                                                        <td>{smsTotalCost.failed}</td>
                                                                                        <td>{smsTotalCost.other}</td>
                                                                                        <td>-</td>
                                                                                        <td>{smsTotalCost.total_cost}</td>
                                                                                        <td>{smsTotalCost.total_cost_parent}</td>
                                                                                        {/* <td>{(parseFloat(smsInnarData?.total_cost) || 0).toFixed(2)}</td> */}
                                                                                    </tr>

                                                                                    {/* RCS */}
                                                                                    <tr>
                                                                                        <td rowSpan="3">
                                                                                            <MdChat style={{ fontSize: '1.8em', color: '#17a2b8' }} className="mr-2" />
                                                                                            RCS
                                                                                        </td>
                                                                                        <td>Text</td>
                                                                                        <td>91</td>
                                                                                        <td>{rcsTotalCost.text.contact_count}</td>
                                                                                        <td>{rcsTotalCost.text.delivered}</td>
                                                                                        <td>{rcsTotalCost.text.failed}</td>
                                                                                        <td>{rcsTotalCost.text.other}</td>
                                                                                        <td>-</td>
                                                                                        <td>{rcsTotalCost.text.block_cr}</td>
                                                                                        <td>{rcsTotalCost.text.block_cr_parent}</td>
                                                                                    </tr>

                                                                                    <tr>
                                                                                        <td>RichCardStandAlone</td>
                                                                                        <td>91</td>
                                                                                        <td>{rcsTotalCost.richcardstandalone.contact_count}</td>
                                                                                        <td>{rcsTotalCost.richcardstandalone.delivered}</td>
                                                                                        <td>{rcsTotalCost.richcardstandalone.failed}</td>
                                                                                        <td>{rcsTotalCost.richcardstandalone.other}</td>
                                                                                        <td>-</td>
                                                                                        <td>{rcsTotalCost.richcardstandalone.block_cr}</td>
                                                                                        <td>{rcsTotalCost.richcardstandalone.block_cr_parent}</td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td>RichCardCarousel</td>
                                                                                        <td>91</td>
                                                                                        <td>{rcsTotalCost.richcardcarousel.contact_count}</td>
                                                                                        <td>{rcsTotalCost.richcardcarousel.delivered}</td>
                                                                                        <td>{rcsTotalCost.richcardcarousel.failed}</td>
                                                                                        <td>{rcsTotalCost.richcardcarousel.other}</td>
                                                                                        <td>-</td>
                                                                                        <td>{rcsTotalCost.richcardcarousel.block_cr}</td>
                                                                                        <td>{rcsTotalCost.richcardcarousel.block_cr_parent}</td>
                                                                                    </tr>

                                                                                    {/* Voice */}
                                                                                    <tr>
                                                                                        <td>
                                                                                            <FaVoicemail style={{ fontSize: '1.8em', color: '#fd7e14' }} className="mr-2" />
                                                                                            Voice
                                                                                        </td>
                                                                                        <td>-</td>
                                                                                        <td>91</td>
                                                                                        <td>{voiceTotalCost.total}</td>
                                                                                        <td>{voiceTotalCost.success}</td>
                                                                                        <td>{voiceTotalCost.failed}</td>
                                                                                        <td>{voiceTotalCost.submitted}</td>
                                                                                        <td>{voiceTotalCost.total_pulse_15p / voiceTotalCost.total_pulse_30p || 0}</td>
                                                                                        <td>{voiceTotalCost.total_cost}</td>
                                                                                        <td>{voiceTotalCost.total_cost_parent}</td>
                                                                                        {/* <td>$12.00</td> */}
                                                                                    </tr>
                                                                                    {/* Email */}
                                                                                    <tr>
                                                                                        <td>
                                                                                            <FaEnvelope style={{ fontSize: '1.8em', color: '#dc3545' }} className="mr-2" />
                                                                                            Email
                                                                                        </td>
                                                                                        <td>-</td>
                                                                                        <td>91</td>
                                                                                        <td>{emailTotalCost.total}</td>
                                                                                        <td>{emailTotalCost.delivered}</td>
                                                                                        <td>{emailTotalCost.failed}</td>
                                                                                        <td>{emailTotalCost.other}</td>
                                                                                        <td>-</td>
                                                                                        <td>{emailTotalCost.total_cost}</td>
                                                                                        <td>{emailTotalCost.total_cost_parent}</td>

                                                                                    </tr>
                                                                                </tbody>

                                                                            </table>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className='row mb-3'>
                                                                    <div className='col-6'>
                                                                        {Object.keys(billData).length > 0 &&
                                                                            <h6>Total Count: {Object.keys(billData).length}</h6>}
                                                                    </div>
                                                                    <div className='col-6'>
                                                                        <div className="input-group float-right">
                                                                            <div className="input-group-prepend">
                                                                                <span className="input-group-text"><FontAwesomeIcon icon={faSearch} /></span>
                                                                            </div>
                                                                            <input
                                                                                type="text"
                                                                                id="searchInput"
                                                                                name="searchdata"
                                                                                value={searchData}
                                                                                onChange={(e) => setSearchData(e.target.value)}
                                                                                className="form-control"
                                                                                placeholder="Search"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="table-responsive">
                                                                    <table className="table table-bordered">
                                                                        <thead>
                                                                            <tr>
                                                                                <th>Action</th>
                                                                                <th>Username</th>
                                                                                <th>Parent Username</th>
                                                                                <th style={{ cursor: "pointer" }} onClick={handleSort}>Total Amount <span
                                                                                    style={{
                                                                                        display: "inline-block",
                                                                                        transition: "transform 0.3s",
                                                                                        // transform: openKeys.includes(x) ? "rotate(180deg)" : "rotate(0deg)",
                                                                                        fontSize: "15px",
                                                                                        color: "white"
                                                                                    }}
                                                                                >
                                                                                    <FontAwesomeIcon icon={faSort} />
                                                                                </span></th>
                                                                                <th>Billing Type</th>
                                                                                <th>Auto Refund</th>
                                                                                <th>Billed/UnBilled</th>
                                                                                <th>History</th>
                                                                            </tr>
                                                                        </thead>
                                                                        {Object.keys(billData)
                                                                            .filter((key) => {
                                                                                if (searchData.trim() === '') {
                                                                                    return true;
                                                                                }
                                                                                const lowerSearch = searchData.toLowerCase();
                                                                                return (
                                                                                    billData[key]?.username.toLowerCase().includes(lowerSearch) ||
                                                                                    billData[key]?.parent_biling_type?.toLowerCase().includes(lowerSearch)
                                                                                );
                                                                            })
                                                                            .map((x) => {
                                                                                let WhatsappData = billData[x]?.whatsapp
                                                                                let sms = billData[x]?.sms
                                                                                let voice = billData[x]?.voice?.api
                                                                                let email = billData[x]?.email?.api
                                                                                let username = billData[x].username
                                                                                let totalAmount = billData[x].totalAmount
                                                                                let parentName = billData[x].parent
                                                                                let rcsParentname = billData[x].parentname
                                                                                let billing_type = billData[x].parent_biling_type
                                                                                let user_billing_type = billData[x].user_biling_type
                                                                                let autoRefund = billData[x].auto_refund
                                                                                let userID = billData[x].user_id
                                                                                let rcsPannel = billData[x]?.rcs?.PANEL?.data
                                                                                let rcsBulkApi = billData[x]?.rcs?.BULKAPI?.data
                                                                                let conversation = billData[x]?.whatsapp?.conv?.sms_cost
                                                                                let rcsDataPannel = ""

                                                                                // console.log(conversation)

                                                                                // Object.entries(conversation).map(([]) => {
                                                                                //     console.log()
                                                                                // })



                                                                                let WhatsappInnerData = {}
                                                                                let WhatsappCampInnerData = {}
                                                                                let smsInnarData = {}
                                                                                let smsCampInnerData = {}
                                                                                let whatsappCountryCode = ""
                                                                                let smsCountryCode = ""
                                                                                let rcstexttemplate = []
                                                                                let rcsrichcardtemplate = []
                                                                                let rcscarouseltemplate = []

                                                                                let rcsTextData = {};
                                                                                let rcsRichCardData = {};
                                                                                let rcsCarouselData = {};

                                                                                let rcsTextBulkData = {};
                                                                                let rcsRichCardBulkData = {};
                                                                                let rcsCarouselBulkData = {};

                                                                                // 1. Collect all unique countryCodes from sms.api and sms.camp
                                                                                const countryCodes = new Set([
                                                                                    ...Object.keys(sms?.api || {}),
                                                                                    ...Object.keys(sms?.camp || {}),
                                                                                ]);

                                                                                Object.keys(WhatsappData?.api || {}).map((whatsappmatch) => {
                                                                                    WhatsappInnerData = WhatsappData.api[whatsappmatch]
                                                                                    whatsappCountryCode = whatsappmatch
                                                                                });

                                                                                // console.log(WhatsappData?.api)

                                                                                Object.keys(WhatsappData?.camp || {}).map((whatsappCampmatch) => {
                                                                                    WhatsappCampInnerData = WhatsappData.camp[whatsappCampmatch]
                                                                                    whatsappCountryCode = whatsappCampmatch
                                                                                });

                                                                                //sms api Data
                                                                                Object.keys(sms?.api || {}).map((smsmatch) => {
                                                                                    smsInnarData = sms.api[smsmatch]
                                                                                    // console.log(smsInnarData)
                                                                                    // console.log(sms.api)
                                                                                    smsCountryCode = smsmatch
                                                                                })
                                                                                // console.log(smsCountryCode)

                                                                                //sms camp Data
                                                                                Object.keys(sms?.camp || {}).map((smsCampmatch) => {
                                                                                    smsCampInnerData = sms.camp[smsCampmatch]
                                                                                    smsCountryCode = smsCampmatch
                                                                                })

                                                                                // if (rcsPannel && Array.isArray(rcsPannel)) {
                                                                                //     rcsPannel.forEach((item) => {
                                                                                //         if (Array.isArray(item)) {
                                                                                //             item.forEach((innerItem) => {
                                                                                //                 // Do something with each innerItem
                                                                                //                 rcsDataPannel = innerItem;
                                                                                //             });
                                                                                //         } else {
                                                                                //             // If item is a single object, not an array
                                                                                //             rcsDataPannel = item;
                                                                                //         }
                                                                                //     });
                                                                                // }
                                                                                if (rcsPannel && Array.isArray(rcsPannel)) {
                                                                                    rcsPannel.forEach(item => {
                                                                                        const dataItem = Array.isArray(item) ? item[0] : item; // Flatten if needed

                                                                                        if (dataItem.rcs_type === "text") {
                                                                                            rcsTextData = dataItem.data || {};
                                                                                        } else if (dataItem.rcs_type === "richcardstandalone") {
                                                                                            rcsRichCardData = dataItem.data || {};
                                                                                        } else if (dataItem.rcs_type === "richcardcarousel") {
                                                                                            rcsCarouselData = dataItem.data || {};
                                                                                        }
                                                                                    });
                                                                                }

                                                                                if (rcsBulkApi && Array.isArray(rcsBulkApi)) {
                                                                                    rcsBulkApi.forEach(item => {
                                                                                        // console.log(rcsPannel);

                                                                                        const dataItem = Array.isArray(item) ? item[0] : item; // Flatten if needed

                                                                                        if (dataItem.rcs_type === "text") {
                                                                                            rcsTextBulkData = dataItem.data || {};
                                                                                        } else if (dataItem.rcs_type === "richcardstandalone") {
                                                                                            rcsRichCardBulkData = dataItem.data || {};
                                                                                        } else if (dataItem.rcs_type === "richcardcarousel") {
                                                                                            rcsCarouselBulkData = dataItem.data || {};
                                                                                        }
                                                                                    });
                                                                                }

                                                                                return (
                                                                                    <tbody key={x}>
                                                                                        <React.Fragment key={x}>
                                                                                            <tr>
                                                                                                <td style={{ cursor: "pointer", width: "40px", textAlign: "center" }}>
                                                                                                    <button
                                                                                                        className="btn btn-link p-0"
                                                                                                        onClick={() => toggleAccordion(x)}
                                                                                                        aria-expanded={openKeys.includes(x)}
                                                                                                        aria-controls={`accordion-collapse-${x}`}
                                                                                                    >
                                                                                                        <span
                                                                                                            style={{
                                                                                                                display: "inline-block",
                                                                                                                transition: "transform 0.3s",
                                                                                                                transform: openKeys.includes(x) ? "rotate(180deg)" : "rotate(0deg)",
                                                                                                                fontSize: "18px",
                                                                                                                color: "black"
                                                                                                            }}
                                                                                                        >
                                                                                                            ▼
                                                                                                        </span>
                                                                                                    </button>
                                                                                                </td>
                                                                                                <td>{username}</td>
                                                                                                <td>
                                                                                                    {parentName || rcsParentname}
                                                                                                    <br />
                                                                                                    <strong>{billing_type && `(${billing_type})`}</strong>
                                                                                                </td>
                                                                                                <td>
                                                                                                    {/* {(
                                                                                                        (parseFloat(smsInnarData?.total_cost) || 0) +
                                                                                                        (parseFloat(smsCampInnerData?.total_cost_user) || 0) +
                                                                                                        (parseFloat(WhatsappInnerData.Utility?.submission_cost_user) || 0) +
                                                                                                        (parseFloat(WhatsappCampInnerData.Utility?.submission_cost_user) || 0) +
                                                                                                        (parseFloat(WhatsappInnerData.Marketing?.submission_cost_user) || 0) +
                                                                                                        (parseFloat(WhatsappCampInnerData.Marketing?.submission_cost_user) || 0) +
                                                                                                        (parseFloat(WhatsappInnerData.Authentication?.submission_cost_user) || 0) +
                                                                                                        (parseFloat(WhatsappCampInnerData.Authentication?.submission_cost_user) || 0) +
                                                                                                        (parseFloat(voice?.total_cost) || 0) +
                                                                                                        (parseFloat(email?.total_cost) || 0) +
                                                                                                        (parseFloat(rcsTextData.block_cr) || 0) +
                                                                                                        (parseFloat(rcsRichCardData.block_cr) || 0) +
                                                                                                        (parseFloat(rcsCarouselData.block_cr) || 0)
                                                                                                    ).toFixed(2)} */}
                                                                                                    {parseFloat(totalAmount).toFixed(6)}
                                                                                                </td>
                                                                                                <td>{user_billing_type ? user_billing_type : <span>Prepaid</span>}</td>
                                                                                                <td>{autoRefund ? autoRefund : "NO"}</td>
                                                                                                <td>
                                                                                                    <select
                                                                                                        value={billStatus[x] || 'unbilled'}  // default to 'unbilled'
                                                                                                        className="form-control"
                                                                                                        onChange={(e) => handleBillStatus(x, e.target.value)}
                                                                                                    >
                                                                                                        <option value="unbilled">UnBilled</option>
                                                                                                        <option value="billed">Billed</option>
                                                                                                    </select>
                                                                                                </td>
                                                                                                <td>
                                                                                                    <a
                                                                                                        href={`/admin/admin-transaction-history/${userID}/${x}`}
                                                                                                        target="_blank"
                                                                                                        rel="noopener noreferrer"
                                                                                                        className="ml-3"
                                                                                                        style={{ cursor: "pointer" }}
                                                                                                    >
                                                                                                        <FontAwesomeIcon icon={faEye} />
                                                                                                    </a>

                                                                                                </td>
                                                                                            </tr>

                                                                                            <tr>
                                                                                                <td colSpan="7" className="p-0 border-0">
                                                                                                    <div
                                                                                                        id={`accordion-collapse-${x}`}
                                                                                                        className={`collapse ${openKeys.includes(x) ? "show" : ""}`}
                                                                                                    >
                                                                                                        {/* accordion content */}
                                                                                                        <div className="p-3 bg-light">
                                                                                                            <div className="card">
                                                                                                                <div className="card-body">
                                                                                                                    <h6 className="mb-3">Detail Report</h6>
                                                                                                                    <div className="table-responsive">
                                                                                                                        <table className="table table-striped table-bordered mb-0">
                                                                                                                            <thead className="bg-secondary text-white">
                                                                                                                                <tr>
                                                                                                                                    <th>Channel</th>
                                                                                                                                    <th>Category</th>
                                                                                                                                    <th>CountryCode</th>
                                                                                                                                    <th>Total</th>
                                                                                                                                    <th>Delivered</th>
                                                                                                                                    <th>Failed</th>
                                                                                                                                    <th>Other</th>
                                                                                                                                    <th>Sent Count</th>
                                                                                                                                    <th>User Pulse (Voice)</th>
                                                                                                                                    <th>Price</th>
                                                                                                                                    <th>User Cost</th>
                                                                                                                                    <th>Parent Cost</th>
                                                                                                                                    {/* <th>Total Cost</th> */}
                                                                                                                                </tr>
                                                                                                                            </thead>
                                                                                                                            <tbody>
                                                                                                                                {/* Whatsapp divided into Utility, Marketing, Authentication */}
                                                                                                                                {(() => {
                                                                                                                                    // 1) Collect all unique country codes from all sources
                                                                                                                                    const countryCodesSet = new Set();
                                                                                                                                    Object.entries(WhatsappData || {}).forEach(([sourceKey, sourceData]) => {
                                                                                                                                        if (!sourceData || typeof sourceData !== 'object') return;
                                                                                                                                        Object.keys(sourceData).forEach(countryCode => countryCodesSet.add(countryCode));
                                                                                                                                    });
                                                                                                                                    const uniqueCountryCodes = Array.from(countryCodesSet);

                                                                                                                                    // Calculate total number of rows (all categories of all countries)
                                                                                                                                    const totalRows = uniqueCountryCodes.reduce((count, countryCode) => {
                                                                                                                                        const dataPerSource = Object.entries(WhatsappData || {}).map(([sourceKey, sourceData]) => {
                                                                                                                                            return sourceData?.[countryCode] || {};
                                                                                                                                        });
                                                                                                                                        const categories = ['Utility', 'Marketing', 'Authentication'].filter(
                                                                                                                                            cat => dataPerSource.some(data => data[cat])
                                                                                                                                        );
                                                                                                                                        return count + categories.length;
                                                                                                                                    }, 0);

                                                                                                                                    let renderedRows = 0; // To track where to place the logo

                                                                                                                                    return uniqueCountryCodes.map(countryCode => {
                                                                                                                                        const dataPerSource = Object.entries(WhatsappData || {}).map(([sourceKey, sourceData]) => {
                                                                                                                                            return sourceData?.[countryCode] || {};
                                                                                                                                        });

                                                                                                                                        const categories = ['Utility', 'Marketing', 'Authentication'].filter(
                                                                                                                                            cat => dataPerSource.some(data => data[cat])
                                                                                                                                        );

                                                                                                                                        const billItem = billData.find(bill => bill.countryCode === countryCode) || {};

                                                                                                                                        return categories.length > 0
                                                                                                                                            ? categories.map((category, catIndex) => {
                                                                                                                                                const combined = dataPerSource.map(data => data?.[category] || {});

                                                                                                                                                const total = combined.reduce((sum, item) => sum + (parseInt(item.total) || 0), 0);
                                                                                                                                                const delivered = combined.reduce((sum, item) => sum + (parseInt(item.delivered) || 0), 0);
                                                                                                                                                const failed = combined.reduce((sum, item) => sum + (parseInt(item.failed) || 0), 0);
                                                                                                                                                const other = combined.reduce((sum, item) => sum + (parseInt(item.other) || 0), 0);
                                                                                                                                                const sentCount = combined.reduce((sum, item) => sum + (parseInt(item.sent_count) || 0), 0);
                                                                                                                                                const per_wp_cost = (
                                                                                                                                                    parseFloat(combined.find(item => item.per_wp_cost)?.per_wp_cost ?? 0)
                                                                                                                                                ).toFixed(6);
                                                                                                                                                const submission_cost_user = combined
                                                                                                                                                    .reduce((sum, item) => sum + (parseFloat(item.submission_cost_user) || 0), 0)
                                                                                                                                                    .toFixed(6);
                                                                                                                                                const submission_cost_parent = combined
                                                                                                                                                    .reduce((sum, item) => sum + (parseFloat(item.submission_cost_parent) || 0), 0)
                                                                                                                                                    .toFixed(6);

                                                                                                                                                renderedRows++;

                                                                                                                                                return (
                                                                                                                                                    <tr key={`${countryCode}-${category}`}>
                                                                                                                                                        {/* Show WhatsApp logo only in the very first row */}
                                                                                                                                                        {renderedRows === 1 && (
                                                                                                                                                            <td rowSpan={totalRows}>
                                                                                                                                                                <IoLogoWhatsapp style={{ fontSize: '1.8em', color: '#25D366' }} className="mr-2" />
                                                                                                                                                                Whatsapp
                                                                                                                                                                <span className="ml-1">
                                                                                                                                                                    {billItem?.whatsappbm === "1" ? "(Delivery)" : "(Submission)"}
                                                                                                                                                                </span>
                                                                                                                                                            </td>
                                                                                                                                                        )}
                                                                                                                                                        <td>{category}</td>
                                                                                                                                                        <td>
                                                                                                                                                            {countryCode} (
                                                                                                                                                            {countryname.find(
                                                                                                                                                                (x) => String(x.country_code) === String(countryCode)
                                                                                                                                                            )?.country_name || "-"}
                                                                                                                                                            )
                                                                                                                                                        </td>
                                                                                                                                                        <td>{total}</td>
                                                                                                                                                        <td>{delivered}</td>
                                                                                                                                                        <td>{failed}</td>
                                                                                                                                                        <td>{other}</td>
                                                                                                                                                        <td>{sentCount}</td>
                                                                                                                                                        <td>-</td>
                                                                                                                                                        <td>{per_wp_cost}</td>
                                                                                                                                                        <td>{submission_cost_user}</td>
                                                                                                                                                        <td>{submission_cost_parent}</td>
                                                                                                                                                    </tr>
                                                                                                                                                );
                                                                                                                                            })
                                                                                                                                            : null;
                                                                                                                                    });
                                                                                                                                })()}

                                                                                                                                {conversation &&
                                                                                                                                    <tr>
                                                                                                                                        <td>Conversation</td>
                                                                                                                                        <table>
                                                                                                                                            <thead>
                                                                                                                                                <tr>
                                                                                                                                                    <th>Price</th>
                                                                                                                                                    <th>Count</th>
                                                                                                                                                </tr>
                                                                                                                                            </thead>
                                                                                                                                            <tbody>
                                                                                                                                                {conversation && typeof conversation === 'object' &&
                                                                                                                                                    Object.entries(conversation).map(([key, value]) => (
                                                                                                                                                        <tr key={key}>
                                                                                                                                                            <td>{key}</td>
                                                                                                                                                            <td>{value}</td>
                                                                                                                                                        </tr>
                                                                                                                                                    ))
                                                                                                                                                }
                                                                                                                                            </tbody>
                                                                                                                                        </table>


                                                                                                                                    </tr>}


                                                                                                                                {/* SMS */}
                                                                                                                                {(() => {
                                                                                                                                    const apiCountries = Object.keys(sms?.api || {});
                                                                                                                                    const campCountries = Object.keys(sms?.camp || {});
                                                                                                                                    const uniqueCountryCodes = Array.from(new Set([...apiCountries, ...campCountries]));

                                                                                                                                    return uniqueCountryCodes.map((countryCode, index) => {
                                                                                                                                        const apiData = sms?.api?.[countryCode] || {};
                                                                                                                                        const campData = sms?.camp?.[countryCode] || {};
                                                                                                                                        const billItem = billData.find(b => b.countryCode === countryCode) || {};

                                                                                                                                        const total = (parseInt(apiData.total) || 0) + (parseInt(campData.total) || 0);
                                                                                                                                        const delivered = (parseInt(apiData.delivered) || 0) + (parseInt(campData.delivered) || 0);
                                                                                                                                        const failed = (parseInt(apiData.failed) || 0) + (parseInt(campData.failed) || 0);
                                                                                                                                        const other = (parseInt(apiData.other) || 0) + (parseInt(campData.other) || 0);
                                                                                                                                        const sentCount = (parseInt(apiData.sent_count) || 0) + (parseInt(campData.sent_count) || 0);

                                                                                                                                        const per_sms_cost = (
                                                                                                                                            parseFloat(apiData.per_sms_cost ?? campData.per_sms_cost ?? 0)
                                                                                                                                        ).toFixed(6);

                                                                                                                                        const total_cost = (
                                                                                                                                            (parseFloat(apiData.total_cost || apiData.total_cost_user) || 0) +
                                                                                                                                            (parseFloat(campData.total_cost || campData.total_cost_user) || 0)
                                                                                                                                        ).toFixed(6);

                                                                                                                                        const total_cost_parent = (
                                                                                                                                            (parseFloat(apiData.total_cost_parent) || 0) +
                                                                                                                                            (parseFloat(campData.total_cost_parent) || 0)
                                                                                                                                        ).toFixed(6);

                                                                                                                                        return (
                                                                                                                                            <tr key={`sms-${countryCode}-${index}`}>
                                                                                                                                                {/* Show SMS logo only in the first row */}
                                                                                                                                                {index === 0 ? (
                                                                                                                                                    <td rowSpan={uniqueCountryCodes.length}>
                                                                                                                                                        <FaSms style={{ fontSize: '1.8em', color: '#007bff' }} className="mr-2" />
                                                                                                                                                        SMS
                                                                                                                                                        <span className="ml-1">
                                                                                                                                                            {billItem?.smsbm === "1" ? "(Delivery)" : "(Submission)"}
                                                                                                                                                        </span>
                                                                                                                                                    </td>
                                                                                                                                                ) : null}

                                                                                                                                                {/* Empty cell for logo column if not first row */}
                                                                                                                                                {index !== 0 && null}

                                                                                                                                                <td>-</td>
                                                                                                                                                <td>
                                                                                                                                                    {countryCode}{" "}
                                                                                                                                                    (
                                                                                                                                                    {countryname == "9999" ? <span>(multiple)</span> :
                                                                                                                                                        countryname.find(
                                                                                                                                                            (x) => String(x.country_code) === String(countryCode)
                                                                                                                                                        )?.country_name || "-"
                                                                                                                                                    }
                                                                                                                                                    )
                                                                                                                                                </td>
                                                                                                                                                <td>{total}</td>
                                                                                                                                                <td>{delivered}</td>
                                                                                                                                                <td>{failed}</td>
                                                                                                                                                <td>{other}</td>
                                                                                                                                                <td>{sentCount}</td>
                                                                                                                                                <td>-</td>
                                                                                                                                                <td>{per_sms_cost}</td>
                                                                                                                                                <td>{total_cost}</td>
                                                                                                                                                <td>{total_cost_parent}</td>
                                                                                                                                            </tr>
                                                                                                                                        );
                                                                                                                                    });
                                                                                                                                })()}


                                                                                                                                {/* RCS */}
                                                                                                                                <tr>
                                                                                                                                    <td rowSpan="3">
                                                                                                                                        <MdChat style={{ fontSize: '1.8em', color: '#17a2b8' }} className="mr-2" />
                                                                                                                                        RCS
                                                                                                                                        <span className="ml-1">
                                                                                                                                            {billData[x].rcsbm == "1" ? <span>(Delivery)</span> : <span>(Submission)</span>}
                                                                                                                                        </span>
                                                                                                                                    </td>
                                                                                                                                    <td>Text</td>
                                                                                                                                    <td>91 (India)</td>
                                                                                                                                    <td>{((rcsTextData.contact_count || 0) + (rcsTextBulkData.contact_count || 0)) || 0}</td>
                                                                                                                                    <td>{((rcsTextData.deliver_count || 0) + (rcsTextBulkData.deliver_count || 0)) || 0}</td>
                                                                                                                                    <td>{((rcsTextData.fail_count || 0) + (rcsTextBulkData.fail_count || 0)) || 0}</td>
                                                                                                                                    <td>{((rcsTextData.other_count || 0) + (rcsTextBulkData.other_count || 0)) || 0}</td>
                                                                                                                                    <td>-</td>
                                                                                                                                    <td>-</td>
                                                                                                                                    <td>{((rcsTextData.block_cr || 0) + (rcsTextBulkData.block_cr || 0)) || 0}</td>
                                                                                                                                    <td>{((rcsTextData.block_cr_parent || 0) + (rcsTextBulkData.block_cr_parent || 0)) || 0}</td>
                                                                                                                                </tr>
                                                                                                                                <tr>
                                                                                                                                    <td>RichCardStandAlone</td>
                                                                                                                                    <td>91 (India)</td>
                                                                                                                                    <td>{((rcsRichCardData.contact_count || 0) + (rcsRichCardBulkData.contact_count || 0)) || 0}</td>
                                                                                                                                    <td>{((rcsRichCardData.deliver_count || 0) + (rcsRichCardBulkData.deliver_count || 0)) || 0}</td>
                                                                                                                                    <td>{((rcsRichCardData.fail_count || 0) + (rcsRichCardBulkData.fail_count || 0)) || 0}</td>
                                                                                                                                    <td>{((rcsRichCardData.other_count || 0) + (rcsRichCardBulkData.other_count || 0)) || 0}</td>
                                                                                                                                    <td>-</td>
                                                                                                                                    <td>-</td>
                                                                                                                                    <td>{((rcsRichCardData.block_cr || 0) + (rcsRichCardBulkData.block_cr || 0)) || 0}</td>
                                                                                                                                    <td>{((rcsRichCardData.block_cr_parent || 0) + (rcsRichCardBulkData.block_cr_parent || 0)) || 0}</td>
                                                                                                                                </tr>
                                                                                                                                <tr>
                                                                                                                                    <td>RichCardCarousel</td>
                                                                                                                                    <td>91 (India)</td>
                                                                                                                                    <td>{((rcsCarouselData.contact_count || 0) + (rcsCarouselBulkData.contact_count || 0)) || 0}</td>
                                                                                                                                    <td>{((rcsCarouselData.deliver_count || 0) + (rcsCarouselBulkData.contact_count || 0)) || 0}</td>
                                                                                                                                    <td>{((rcsCarouselData.fail_count || 0) + (rcsCarouselBulkData.contact_count || 0)) || 0}</td>
                                                                                                                                    <td>{((rcsCarouselData.other_count || 0) + (rcsCarouselBulkData.contact_count || 0)) || 0}</td>
                                                                                                                                    <td>-</td>
                                                                                                                                    <td>-</td>
                                                                                                                                    <td>{((rcsCarouselData.block_cr || 0) + (rcsCarouselBulkData.contact_count || 0)) || 0}</td>
                                                                                                                                    <td>{((rcsCarouselData.block_cr_parent || 0) + (rcsCarouselBulkData.contact_count || 0)) || 0}</td>
                                                                                                                                </tr>

                                                                                                                              
                                                                                                                                <tr>
                                                                                                                                    <td>
                                                                                                                                        <FaVoicemail style={{ fontSize: '1.8em', color: '#fd7e14' }} className="mr-2" />
                                                                                                                                        Voice
                                                                                                                                        <span className="ml-1">{billData[x].voicebm == "1" ? <span>(Delivery)</span> : <span>(Submission)</span>}</span>
                                                                                                                                    </td>
                                                                                                                                    <td>-</td>
                                                                                                                                    <td>91 (India)</td>
                                                                                                                                    <td>{voice?.total || 0}</td>
                                                                                                                                    <td>{voice?.success || 0}</td>
                                                                                                                                    <td>{voice?.failed || 0}</td>
                                                                                                                                    <td>{voice?.submitted || 0}</td>
                                                                                                                                    <td>{voice?.user_pulse === "15" ? voice?.total_pulse_15p : voice?.user_pulse === "30" ? voice?.total_pulse_30p : 0}</td>
                                                                                                                                    <td>-</td>
                                                                                                                                    <td>{parseFloat(voice?.total_cost || 0).toFixed(6)}</td>
                                                                                                                                    <td>{parseFloat(voice?.total_cost_parent || 0).toFixed(6)}</td>
                                                                                                                                    {/* <td>$12.00</td> */}
                                                                                                                                </tr>
                                                                                                                                {/* Email */}
                                                                                                                                <tr>
                                                                                                                                    <td>
                                                                                                                                        <FaEnvelope style={{ fontSize: '1.8em', color: '#dc3545' }} className="mr-2" />
                                                                                                                                        Email
                                                                                                                                        <span className="ml-1">{billData[x].emailbm == "1" ? <span>(Delivery)</span> : <span>(Submission)</span>}</span>
                                                                                                                                    </td>
                                                                                                                                    <td>-</td>
                                                                                                                                    <td>91 (India)</td>
                                                                                                                                    <td>{email?.total || 0}</td>
                                                                                                                                    <td>{email?.delivered || 0}</td>
                                                                                                                                    <td>{email?.failed || 0}</td>
                                                                                                                                    <td>{email?.other || 0}</td>
                                                                                                                                    <td>-</td>
                                                                                                                                    <td>{parseFloat(email?.per_email_cost || 0).toFixed(6)}</td>
                                                                                                                                    <td>{parseFloat(email?.total_cost || 0).toFixed(6)}</td>
                                                                                                                                    <td>{parseFloat(email?.total_cost_parent || 0).toFixed(6)}</td>

                                                                                                                                </tr>
                                                                                                                            </tbody>

                                                                                                                        </table>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </td>
                                                                                            </tr>
                                                                                        </React.Fragment>
                                                                                    </tbody>
                                                                                )
                                                                            })}

                                                                    </table>
                                                                </div>


                                                                {/* 
                                                                <ul className="pagination mt-3">
                                                                    {Array.from({ length: totalPages }).map((_, index) => (
                                                                        <li key={index} className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}>
                                                                            <button className="page-link" onClick={() => handlePagination(index + 1)}>
                                                                                {index + 1}
                                                                            </button>
                                                                        </li>
                                                                    ))}
                                                                </ul> */}
                                                            </> :
                                                            <div className="text-center">
                                                                <div className="card-body">
                                                                    <img alt="Empty Data" className="project-empty-img" src={EmptyImg} />
                                                                    <p>No Data Yet</p>
                                                                </div>
                                                            </div>
                                                        }

                                                        {/* {this.state.enitytList && 
                                                                <AdvanceDataTable
                                                                    tableName={""}
                                                                    tableCell={ENTITY_MANAGEMENT_LIST}
                                                                    tableData={this.state.enitytList}
                                                                    pagination={true}
                                                                    EditEntityID={this.EditEntityID}
                                                                    userList = {this.state.allUsers}
                                                                    // isLoading={this.state.setIsLoading}
                                                                    // isError={this.state.ErrorResponse}
                                                                />} */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </AdminLayout >
            {enterOtp &&
                <div
                    className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
                    style={{ background: 'rgba(0,0,0,0.5)', zIndex: 1050 }}
                >
                    <div className="bg-white p-4 rounded shadow" style={{ width: '300px' }}>
                        <h5 className="mb-3">Enter OTP</h5>
                        <input
                            type="text"
                            className="form-control mb-3"
                            placeholder="Enter your OTP"
                            value={otp}
                            onChange={(e) => setOtp(e.target.value)}
                        />
                        <div className="d-flex justify-content-end">
                            <button className="btn btn-secondary me-2" onClick={() => setEnterOtp(false)}>Cancel</button>
                            <button className="btn btn-primary" onClick={""}>Submit</button>
                        </div>
                    </div>
                </div>
            }
        </div >
    );
};

export default BillingReport;
